import { lazy, type ComponentType } from "react";

export class PageLoadError extends Error {
  readonly cause: unknown;

  constructor(cause: unknown) {
    super(cause instanceof Error ? cause.message : String(cause));
    this.name = "PageLoadError";
    this.cause = cause;
  }
}

// Mobile connections occasionally drop a chunk request; retry before showing the reload screen.
const DEFAULT_RETRY_DELAYS_MS = [500, 1500];

export function lazyPage(
  load: () => Promise<{ default: ComponentType }>,
  retryDelaysMs: readonly number[] = DEFAULT_RETRY_DELAYS_MS,
) {
  return lazy(async () => {
    for (let attempt = 0; ; attempt++) {
      try {
        return await load();
      } catch (cause) {
        if (attempt >= retryDelaysMs.length) throw new PageLoadError(cause);
        await new Promise((resolve) => setTimeout(resolve, retryDelaysMs[attempt]));
      }
    }
  });
}
